// https://talkytimes.com/platform/icebreakers/limits

import { requestPDServer } from '@/utils/fetchResponse';
const myBaseUrl = process.env.VUE_APP_BASE_API;
import Cookies from 'js-cookie';
// const userInfo = store.getters['socket/getUserInfo'](platformUserId);

// 获取icebreakers可创建数量
export const getIcebreakersLimits = (data) => {
  return requestPDServer('/platform/icebreakers/limits', data);
};

// https://talkytimes.com/platform/icebreakers/list
// 获取icebreakers列表
export const getIcebreakersList = (data) => {
  return requestPDServer('/platform/icebreakers/list', data);
};
// https://talkytimes.com/platform/icebreakers/count-by-status
// 获取icebreakers状态数量
export const getIcebreakersCountByStatus = (data) => {
  return requestPDServer('/platform/icebreakers/count-by-status', data);
};
// https://talkytimes.com/platform/icebreakers/list/mail-to-launch
// 获取邮件发送列表
export const getIcebreakersListMailToLaunch = (data) => {
  return requestPDServer('/platform/icebreakers/list/mail-to-launch', data);
};
// 获取聊天发送列表
export const getIcebreakersListMessageToLaunch = (data) => {
  return requestPDServer('/platform/icebreakers/list/message-to-launch', data);
};
// https://talkytimes.com/platform/icebreakers/launched
// 获取已发送的icebreakers列表
export const getIcebreakersLaunched = (data) => {
  return requestPDServer('/platform/icebreakers/launched', data);
};
// https://talkytimes.com/platform/icebreakers/star
// 收藏icebreakers
export const starIcebreakers = (data) => {
  return requestPDServer('/platform/icebreakers/star', data);
};
// https://talkytimes.com/platform/icebreakers/unstar
// 取消收藏icebreakers
export const unstarIcebreakers = (data) => {
  return requestPDServer('/platform/icebreakers/unstar', data);
};
// 创建icebreakers
// https://talkytimes.com/platform/icebreakers/create
// content: 消息内容
// gender: 性别
// moods: 心情 ['hot_talks','real_love','friendship']
// type: 类型 'message'/'mail'
// idPhoto: 图片id
export const createIcebreakers = (data) => {
  return requestPDServer('/platform/icebreakers/create', data);
};
// 重新提交icebreakers
// https://talkytimes.com/platform/icebreakers/disagree
// id: 唯一标识
export const disagreeIcebreakers = (data) => {
  return requestPDServer('/platform/icebreakers/disagree', data);
};
// 启动icebreakers邮件
// https://talkytimes.com/platform/icebreaker/switch-on
// id: 唯一标识
export const switchOnIcebreakers = (data) => {
  return requestPDServer('/platform/icebreaker/switch-on', data);
};
// 停止icebreakers邮件
// https://talkytimes.com/platform/icebreakers/group/stop
// id: 唯一标识
export const stopIcebreakers = (data) => {
  return requestPDServer('/platform/icebreakers/group/stop', data);
};
// 启动icebreakers聊天
// https://talkytimes.com/platform/icebreakers/group/create
// 参数：
// icebreakers:[{mood:"hot_talks",idIcebreaker: 14553704},{mood:"real_love",idIcebreaker:145537042,{mood:"friendship",idIcebreaker:14553704}]
// type:"message
export const createIcebreakersGroup = (data) => {
  return requestPDServer('/platform/icebreakers/group/create', data);
};
// 删除icebreakers
// https://talkytimes.com/platform/icebreakers/delete
// idsIcebreakers: [14553704]
export const deleteIcebreakers = (data) => {
  return requestPDServer('/platform/icebreakers/delete', data);
};

const setCookie = () => {
  const activeUser = localStorage.getItem('activeUser');
  if (activeUser) {
    const user = JSON.parse(activeUser);
    Cookies.set('tld-token', user.pdToken);
  }
};
